/**
 * Centralized NAP (Name, Address, Phone) Constants
 * ================================================
 * Single source of truth for all business contact information.
 * Update these values here to propagate across the entire site.
 */

export const BUSINESS_INFO = {
  // Business Identity
  name: "Groomie Roomie",
  legalName: "Groomie Roomie Mobile Pet Grooming LLC",
  foundingYear: "2020",
  
  // Primary Contact
  phone: {
    display: "(720) 243-2853",
    tel: "+17202432853",
    digits: "7202432853",
    sms: "sms:+17202432853?&body=Hi!%20I'm%20interested%20in%20mobile%20grooming.%20Do%20you%20serve%20my%20area?%20My%20ZIP%20code%20is%3A",
  },
  email: "groomieroomie@gmail.com",
  
  // Primary Address
  address: {
    street: "3144 W Frances Walsh Pl",
    city: "Denver",
    state: "CO",
    zip: "80236",
    country: "US",
    full: "3144 W Frances Walsh Pl, Denver, CO 80236",
  },
  
  // Business Hours
  hours: {
    weekdays: "Mon-Sat: 8am - 6pm",
    weekend: "Sun: Closed",
    schema: "Mo-Sa 08:00-18:00",
  },
  
  // Online Presence
  website: {
    url: "https://groomieroomie.com",
    domain: "groomieroomie.com",
  },
  
  // Social Media
  social: {
    instagram: "https://www.instagram.com/groomie_roomie_denver_",
    tiktok: "https://www.tiktok.com/@groomie_roomie_denver",
    facebook: "https://www.facebook.com/groomieroomie",
    twitter: "@groomieroomie",
  },
  
  // Service Info
  service: {
    type: "Mobile Dog & Cat Grooming",
    priceRange: "$$",
    primaryArea: "Denver Metro Area",
  },
  
  // Aggregate Rating
  rating: {
    value: "4.9",
    count: "200",
    best: "5",
    worst: "1",
  },
} as const;

// Helper function to get full address string
export const getFullAddress = () => BUSINESS_INFO.address.full;

// Helper function to get phone link
export const getPhoneLink = (type: 'tel' | 'sms' = 'tel') => 
  type === 'sms' ? BUSINESS_INFO.phone.sms : `tel:${BUSINESS_INFO.phone.tel}`;

// Helper function to get email link
export const getEmailLink = () => `mailto:${BUSINESS_INFO.email}`;

// Schema.org address object
export const getSchemaAddress = () => ({
  "@type": "PostalAddress",
  streetAddress: BUSINESS_INFO.address.street,
  addressLocality: BUSINESS_INFO.address.city,
  addressRegion: BUSINESS_INFO.address.state,
  postalCode: BUSINESS_INFO.address.zip,
  addressCountry: BUSINESS_INFO.address.country,
});

// Schema.org contact point
export const getSchemaContactPoint = () => ({
  "@type": "ContactPoint",
  telephone: BUSINESS_INFO.phone.tel,
  contactType: "customer service",
  areaServed: "US",
  availableLanguage: ["English", "Spanish"],
});
